import React from 'react';
import PropTypes from 'prop-types';
import {
  Message,
  MessageHeader,
  MessageItem,
  MessageList,
} from 'semantic-ui-react';

function ApprovalStatusMessage({
  approvalLogs: { logs, last_log: lastLog },
  currentStatus,
}) {
  const messageStatusColor = () => {
    switch (currentStatus) {
      case 'approved':
        return { positive: true };
      case 'rejected':
        return { negative: true };
      default:
        return { info: true };
    }
  };

  const messageStatusText = () => {
    switch (currentStatus) {
      case 'approved':
        return 'Approved';
      case 'rejected':
        return 'Rejected';
      default:
        return 'Updated';
    }
  };

  return (
    !!currentStatus &&
    lastLog !== null && (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Message {...messageStatusColor()}>
        <MessageHeader>{messageStatusText()}</MessageHeader>
        <MessageList>
          {logs.map(({ time, log }) => (
            <MessageItem>
              [{time}] {log}
            </MessageItem>
          ))}
        </MessageList>
      </Message>
    )
  );
}

const logItemPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  time: PropTypes.string.isRequired,
  log: PropTypes.string.isRequired,
});

ApprovalStatusMessage.propTypes = {
  approvalLogs: PropTypes.shape({
    last_log: logItemPropTypes,
    logs: PropTypes.arrayOf(logItemPropTypes),
  }).isRequired,
  currentStatus: PropTypes.string.isRequired,
};

export default ApprovalStatusMessage;
